<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="closeModal()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular">  {{('keys.data.violations.pay_your_ticket' | translate : {Default:'Pay Ticket'}) ||
                'Pay Ticket'}}</h2>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-pagecontent  [path]="'ticket-lookup'"></app-pagecontent>
  <app-loading-spinner  *ngIf="!dataSRV.csrfToken"></app-loading-spinner>
<ion-grid *ngIf="dataSRV.csrfToken">
  <ion-row>
    <ion-col>
      <ion-searchbar 
      (ionChange)="resetSearch()"
      #searchInput
      [(ngModel)]="searchText"
      animated="true" placeholder="{{('keys.data.violations.ticket' | translate)}}"></ion-searchbar>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col style="text-align: center;">
      <ion-button [disabled]="searchText.trim().length<1" color="primary"  (click)="searchTicket()">Search</ion-button>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="ticketResult['status']=='error' && !loadingResult" style="  
  align-items: center;
 ">
  <ion-col>
    <ion-item lines="none"  style="text-align: center">
       <ion-label class="ion-text-wrap">
        {{ ('keys.data.violations.no_violation_found' | translate : {Default:'No violation was found with the ticket information you have supplied.'}) || "No violation was found with the ticket information you have supplied."}}
       </ion-label>
      </ion-item>
  </ion-col>
  </ion-row>
  <ion-row *ngIf="ticketResult['status']=='success' && !loadingResult">
    <ion-col class="single-col-wider">
      <ion-card class="card-shadow-7"> 
        
                    <ion-grid>
                      <ion-row>
                        <ion-col>
                         <ion-item lines="none">
                          <ion-label class="card-header-unique"> {{ticketResult['violation']['Ticket']}}</ion-label>
                         </ion-item>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf=" this.ticketResult?.isGuestPaymentsEnabled">
                        <ion-col>
                        <ion-item lines="none">
                          <ion-label class="ion-text-wrap paragraph-regular" >
                            {{ ('keys.data.common.total' | translate : {Default:'Total'}) || "Total"}}:
                          </ion-label>
                          <ion-label class="ion-text-right">
                            {{ticketResult['violation']['Fine'] |
                            currency}}
                          </ion-label>
                        </ion-item>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf=" this.ticketResult?.isGuestPaymentsEnabled">
                        <ion-col>
                          <ion-button (click)="checkoutTicket()" expand="block" color="primary">
                            {{ ('keys.data.payments.quick_pay' | translate : {Default:'Quick pay'}) || "Quick pay"}}
                          </ion-button>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="!ticketResult['violation']['email']">
                        <ion-col style="text-align: center">
                        <ion-card class="card-shadow-7">
                          <ion-grid>
                            <ion-row *ngIf="hasEmail">
                              <ion-col>
                                <ion-label class="card-text-regular">
                                  {{ ('keys.data.violations.ticket_can_be_appealed' | translate : {Default:'This ticket can be appealed.'}) || "This ticket can be appealed."}}
                                </ion-label>
                              </ion-col>
                            </ion-row>
                            <ion-row>
                              <ion-col size="10" offset="1">
                                <ion-button fill="outline"  (click)="goToLogin()" expand="block" color="secondary" >{{('keys.data.auth.login' | translate : {Default:'login'}) || 'login'}}</ion-button>
                              </ion-col>
                            </ion-row>
                            <ion-row>
                              <ion-col style="text-align: center">
                                <ion-label class="card-text-regular" >{{('keys.data.common.or' | translate : {Default:'or'}) || 'or'}}</ion-label>
                              </ion-col>
                            </ion-row>
                            <ion-row>
                              <ion-col size="10" offset="1" >
                                <ion-button fill="outline"  (click)="goToCreateAccount()" expand="block"  color="secondary">{{('keys.data.users_login.create_account' | translate : {Default:'create account'}) || 'create account'}}</ion-button>
                              </ion-col>
                            </ion-row>
                          </ion-grid>
                        </ion-card>
                        </ion-col>
                      </ion-row>
                      <ion-row *ngIf="ticketResult['violation']['email'] && dataSRV.settings['violations']['enabled']"> 
                        <ion-col [formGroup]="emailForm">
                          <ion-card>
                            <ion-grid>
                              <ion-row>
                                <ion-col style="text-align: center">
                                 <ion-label class="card-text-regular">
                                  {{ ('keys.data.violations.to_appeal_provide_one_more' | translate : {Default:'To appeal or pay this ticket through your account, provide one more piece of information to verify your account.'}) || "To appeal or pay this ticket through your account, provide one more piece of information to verify your account."}}
                                 </ion-label>
                                </ion-col>
                              </ion-row>
                              <ion-row>
                                <ion-col style="text-align: center">
                                 <ion-label class="card-text-regular"> {{ ('keys.data.violations.complete_email_to_verify' | translate : {Default:'Please complete the email address to have a password sent to the provided email.'}) || "Please complete the email address to have a password sent to the provided email."}}</ion-label>
                                </ion-col>
                              </ion-row>
                              <ion-row>
                                <ion-col style="text-align: center">
                                 <ion-label style="font-weight: bold"> {{ ticketResult['violation']['email']}}</ion-label>
                                </ion-col>
                              </ion-row>
                              <ion-row>
                                <ion-col>
                                  <ion-card class="card-shadow-3">
                                  <ion-item >
                                    <ion-label color="dark" position="floating">{{
                                      ('keys.data.profile.email' | translate : {Default:'Email Address'}) || 'Email Address'
                                    }}:</ion-label>
                                    <ion-input 
                                    (ionChange)="clearErrors()"
                                    [disabled]="verifyLoading"
                                    formControlName="email"
                                    required
                                    pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$"
                                    type="email">

                                    </ion-input>
                                  </ion-item>
                                </ion-card>
                                </ion-col>
                              </ion-row>
                              <ion-row>
                                <ion-col>
                                  <ion-button
                                  color="primary"
                                  (click)="emailLogin()"
                                   [disabled]="!emailForm.valid || verifyLoading" expand="block">{{
                                    ('keys.data.violations.verify' | translate : {Default:'Verify'}) || 'Verify'
                                  }}<ion-spinner *ngIf="verifyLoading" style="--color: white"></ion-spinner
                                    ></ion-button>
                                </ion-col>
                              </ion-row>
                              <ion-row *ngIf="isFalsey">
                                <ion-col *ngIf="loginResult['errors']" style="text-align: center">
                                  <ion-note *ngIf="loginResult['errors']['email'][0]"  color="danger">{{loginResult['errors']['email'][0]}}</ion-note>
                                </ion-col>
                                <ion-col *ngIf="loginResult['message']" style="text-align: center">
                                  <ion-note color="danger">{{loginResult['message']}}</ion-note>
                                </ion-col>
                              </ion-row>
                            </ion-grid>
                          </ion-card>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                   
      </ion-card>
    </ion-col>
  </ion-row>
  <ion-row *ngIf="loadingResult">
    <ion-col>
      <ion-card>
        <ion-card-header style="text-align: center; font-weight: bold">
          <ion-title
            ><ion-skeleton-text
              animated
              style="width: 60%"
            ></ion-skeleton-text
          ></ion-title>
          <ion-card-subtitle
            ><ion-skeleton-text
              animated
              style="width: 60%"
            ></ion-skeleton-text
          ></ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <ion-row>
            <ion-col>
              <ion-item>
                <ion-skeleton-text
                  animated
                  style="width: 40%"
                ></ion-skeleton-text>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-item>
                <ion-skeleton-text
                  animated
                  style="width: 40%"
                ></ion-skeleton-text>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-item>
                <ion-skeleton-text
                  animated
                  style="width: 40%"
                ></ion-skeleton-text>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
</ion-content>
